import styled from "styled-components";

export const SectionButton = styled.div`
  margin-top: -0.8rem !important;
  padding: 0 !important;
`;